import {useSelector} from "react-redux";
import {RootState} from "@/store";
import {ModalConstant} from "@/util/constant/ModalConstant.ts";
import CreateNewWorkSpaceModal from "@/components/modal/CreateNewWorkSpaceModal.tsx";
import DeleteWorkSpaceModal from "@/components/modal/DeleteWorkSpaceModal.tsx";
import DeleteApplicationModal from "@/components/modal/DeleteApplicationModal.tsx";
import AuthConfigModal from "@/components/modal/AuthConfigModal.tsx";
import DeleteEntityModal from "@/components/modal/DeleteEntityModal.tsx";
import InviteMemberModal from "@/components/modal/InviteMemberModal.tsx";


export const RenderModalComponents = () => {
    const baseState = useSelector((state: RootState) => state.base)
    if (!baseState?.modalOptions.show) {
        return <></>
    }
    if (baseState.modalOptions.component == ModalConstant.createWorkSpace) {
        return <CreateNewWorkSpaceModal/>
    }
    if (baseState.modalOptions.component == ModalConstant.deleteWorkSpace) {
        return <DeleteWorkSpaceModal/>
    }
    if (baseState.modalOptions.component == ModalConstant.deleteApplication) {
        return <DeleteApplicationModal/>
    }
    if (baseState.modalOptions.component == ModalConstant.authConfig) {
        return <AuthConfigModal/>
    }
    if (baseState.modalOptions.component == ModalConstant.deleteEntity) {
        return <DeleteEntityModal/>
    }
    if (baseState.modalOptions.component == ModalConstant.newMember) {
        return <InviteMemberModal/>
    }
    // if (baseState.modalOptions.component == ModalConstant.accountCreated) {
    //     return <AccountCreated/>
    // }
    // if (baseState.modalOptions.component == ModalConstant.notificationModal) {
    //     return <NotificationModal/>
    // }

}